import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import clsx from 'clsx';

const useStyles = makeStyles({
    root: {
        position: 'relative'
    },
    btn: {
        border: '1px solid #555',
        '&:hover': {
            border: '1px solid #3f51b4',
        },
        padding: '0px 10px',
        paddingRight: 35,
        borderRadius: 2,
        minWidth: 125,
        ['@media (max-width:700px)']: {
            minWidth: 50,
            padding: '5px 10px',
            paddingRight: 35,
            borderRadius: 4,
        },
        cursor: 'pointer',
        '& p': {
            fontSize: '.9rem',
            color: '#555',
            '&:hover': {
                color: '#3f51b4',
            },
        }
    },
    btnSelection: {
    },
    icon: {
        position: 'absolute',
        top: 0,
        right: 0,
        paddingRight: 1,
        height: 23,
        ['@media (max-width:700px)']: {
            height: 32,
        },
        borderLeft: '1px solid #555',
    },
    popUp: {
        display: 'none',
        position: 'absolute',
        right: 4,
        ['@media (min-width:1200px)']: {
            right: 0,
        },
        top: 25,
        ['@media (max-width:700px)']: {
            top: 40,
            right: 0,
        },
        backgroundColor: '#fff',
        borderRadius: 4,
        border: '1px solid #ddd',
        zIndex: 100,
        minWidth: 170,
        '& li': {
            cursor: 'pointer',
            padding: '4px 10px',
            listStyle: 'none',
            '&:hover': {
                backgroundColor: '#efefef',
            },
            '& p': {
                whiteSpace: 'nowrap',
                fontSize: '0.9rem',
                ['@media (max-width:700px)']: {
                    fontSize: '1rem',
                },
            }
        },
    },
    active: {
        fontWeight: 'bold'
    },
});

export default function SortingDesktop(props) {

    const [open, setOpen] = React.useState(false);

    const [closedOn, setClosedOn] = React.useState(0);

    const [counter, setCounter] = React.useState(0);

    const inputRef = React.createRef();

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    React.useEffect(()=> {
        window.document.body.removeEventListener('click', handleClickOutside);
        window.document.body.addEventListener('click', handleClickOutside);
        return () => {
            window.document.body.removeEventListener('click', handleClickOutside);
        }
    });

    const handleClickOutside = (e) => {
        if (open) {
            setOpen(false);
            setClosedOn((new Date()).getTime());
           // e.stopPropagation();
        }
    };

    const handleOpen = (e) => {
        if (!closedOn || ((new Date).getTime() - closedOn) > 100) {
            setOpen(true);
        }
    };

    const handleClick = (e, value) => {
        console.log('value', value)
        e.stopPropagation();
        filter.params.sorting = value;
        localStorage.setItem('sorting', value);
        filter.dispatchFilter();
        render();
    };

    let label = '';

    if (props.isMobile) {
        switch (params.sorting) {
            case 'popular-first':
                label = 'Popular';
                break;
            case 'newest-first':
                label = 'Newest';
                break;
            case 'oldest-first':
                label = 'Oldest';
                break;
            case 'lowest-price':
                label = 'Price △';
                break;
            case 'highest-price':
                label = 'Price ▽';
                break;
            case 'lowest-mileage':
                label = 'Mileage △';
                break;
            case 'highest-mileage':
                label = 'Mileage ▽';
                break;
            case 'most-hits':
                label = 'Hits ▽';
                break;
            case 'least-hits':
                label = 'Hits △';
                break;
            default:
                label = 'Popular';
                break;
        }
    } else {
        switch (params.sorting) {
            case 'popular-first':
                label = 'Popular Offers First';
                break;
            case 'newest-first':
                label = 'Newest Offers First';
                break;
            case 'oldest-first':
                label = 'Oldest Offers First';
                break;
            case 'lowest-price':
                label = 'Lowest Price First';
                break;
            case 'highest-price':
                label = 'Highest Price First';
                break;
            case 'lowest-mileage':
                label = 'Lowest Mileage First';
                break;
            case 'highest-mileage':
                label = 'Highest Mileage First';
                break;
            case 'most-hits':
                label = 'Most Hits First';
                break;
            case 'least-hits':
                label = 'Least Hits First';
                break;
            default:
                label = 'Popular Offers First';
                break;
        }
    }

    const render = () => {
        setCounter(counter + 1);
    };

    const getClass = (type) => {
        return params.sorting === type ? classes.active : null
    };

    console.log('props.user', props);
    return (<>
        <div className={classes.root}>
            <div className={clsx(classes.btn, params.hasSelection ? classes.btnSelection : null)} onClick={handleOpen}>
                <Typography>{label} <ExpandMoreOutlinedIcon className={classes.icon}/></Typography>
            </div>
            <div className={classes.popUp} style={open ? {display: 'block'} : {display: 'none'}}>
                <ul>
                    <li onClick={(e) => handleClick(e, 'popular-first')}>
                        <Typography className={getClass('popular-first')}>Popular Offers First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'newest-first')}>
                        <Typography className={getClass('newest-first')}>Newest Offers First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'oldest-first')}>
                        <Typography className={getClass('oldest-first')}>Oldest Offers First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'lowest-price')}>
                        <Typography className={getClass('lowest-price')}>Lowest Price First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'highest-price')}>
                        <Typography className={getClass('highest-price')}>Highest Price First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'lowest-mileage')}>
                        <Typography className={getClass('lowest-mileage')}>Lowest Mileage First</Typography>
                    </li>
                    <li onClick={(e) => handleClick(e, 'highest-mileage')}>
                        <Typography className={getClass('highest-mileage')}>Highest Mileage First</Typography>
                    </li>
                    {props.user && props.user.isManager ?
                        <>
                        <li onClick={(e) => handleClick(e, 'most-hits')}>
                            <Typography className={getClass('most-hits')}>Most Hits First</Typography>
                        </li>
                        <li onClick={(e) => handleClick(e, 'least-hits')}>
                            <Typography className={getClass('least-hits')}>Least Hits First</Typography>
                        </li>
                        </> : null}
                </ul>
            </div>
        </div>
    </>)
}